const namespace = "question";

export const question = `${namespace}_list`;
export const question_category = `${namespace}_category_list`;
export const question_category_select = `${namespace}_category_select`;

export const status_select = `${namespace}_status_select`;
export const question_type_select = `${namespace}_type_select`;

export const lesson_select = `${namespace}_lesson_select`;
export const test_select = `${namespace}_test_select`;

export const level_select = `${namespace}_level_select`;
export const subject_select = `${namespace}_subject_select`;
export const topic_select = `${namespace}_topic_select`;